import {createSelector} from 'reselect';
import {Document} from '../../../screens/profile/common/documents/model';
import {AppState} from '../../index';

export const documentsSelector = (state: AppState) => state.documents.documents;

export const filteredDocumentsSelector = (filter: (item: Document) => boolean = () => true) =>
  createSelector(
    (state: AppState) => state.documents.documents,
    (items) => (items ? items.filter(filter) : items),
  );

export const documentsDataLoadingSelector = (state: AppState) => state.documents.dataLoading;
